import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./LogoTicker.css";

gsap.registerPlugin(ScrollTrigger);

const LogoTicker = () => {
  const sectionRef = useRef(null);
  const labelRef = useRef(null);
  const itemsRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        labelRef.current,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );

      gsap.fromTo(
        itemsRef.current,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className="logo-ticker" ref={sectionRef}>
      <p className="logo-ticker__label" ref={labelRef}>TRUSTED TOOLS & PLATFORMS</p>
      <div className="logo-ticker__track">
        <div className="logo-ticker__item" ref={(el) => (itemsRef.current[0] = el)}>
          <img src="/assets/logos/meta.svg" alt="Meta" />
        </div>
        <div className="logo-ticker__item" ref={(el) => (itemsRef.current[1] = el)}>
          <img src="/assets/logos/google.svg" alt="Google" />
        </div>
        <div className="logo-ticker__item" ref={(el) => (itemsRef.current[2] = el)}>
          <img src="/assets/logos/stripe.svg" alt="Stripe" />
        </div>
        <div className="logo-ticker__item" ref={(el) => (itemsRef.current[3] = el)}>
          <img src="/assets/logos/zapier.svg" alt="Zapier" />
        </div>
      </div>
    </div>
  );
};

export default LogoTicker;
